<template>
    <div class="col-md-12">
        <div class="pt-3">
            <div class="row my-3">
                <div class="col-md-8">
                    <div class="h2">Goods</div>
                    <div class="flash-message">
                        <FlashMessage :position="'top'"></FlashMessage>
                    </div>
                </div>
                <div class="col-md-4">
                    <div v-if="role !== 'user'" class="button-container">
                        <div class="btn btn-success" title="send list of received goods">
                            <span @click="toggleModalEmail()">Send list of received goods</span>
                        </div>
                        <div class="btn btn-primary" title="add image(s)">
                            <span @click="toggleModalImage()">Add image</span>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="position-relative pagination-control">
                    <data-table
                        :url="tableUrl"
                        :filters="filters"
                        :columns="columns"
                        :per-page="perPage"
                        :translate="translate"
                        :classes="classes"
                        :order-by="orderBy"
                        :order-dir="orderDir"
                        :meta="columns.meta"
                        ref="table"
                        :debounce-delay=1000
                    >
                        <div slot="filters" slot-scope="{ tableFilters, perPage, collis }">
                            <div class="row my-3 d-flex justify-content-end align-items-center">
                                <div class="col-md-3 additional-filters-">
                                    <label class="d-block mb-0 font-weight-bold">Select warehouse </label>
                                    <v-select
                                        @input="getDimensionsSum()"
                                        :options="warehouseList"
                                        :closeOnSelect="false"
                                        v-model="filters.warehouseId"
                                        label="nickname"
                                    >
                                    </v-select>
                                </div>

                                <div class="col-md-3 additional-filters-">
                                    <div v-if="role !== 'user'">
                                        <label class="d-block mb-0 font-weight-bold"> Select Client </label>
                                        <v-select
                                            @input="getDimensionsSum()"
                                            :options="clientList"
                                            :closeOnSelect="false"
                                            v-model="filters.clientId"
                                            label="name"
                                        >
                                        </v-select>
                                    </div>
                                </div>

                                <div class="col-md-1 additional-filters">
                                    <small>
                                        <label class="font-weight-bold">Weight </label>
                                        {{ parseFloat(dimensions.weight).toFixed(2).toString().replace('.', ",") }}
                                        <small> kg </small> <br/>
                                        <label class="font-weight-bold">Volume </label>
                                        {{ parseFloat(dimensions.volume).toFixed(2).toString().replace('.', ",") }}
                                        <small> m3 </small><br/>
                                    </small>
                                </div>

                                <div class="col-md-2 additional-filters">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="showDelivered"
                                               v-model="filters.showDelivered">
                                        <label class="custom-control-label" for="showDelivered">
                                            <b>Show delivered:</b>
                                        </label>
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="excludeBookings"
                                               v-model="filters.excludeBookings">
                                        <label class="custom-control-label" for="excludeBookings">
                                            <b>Exclude bookings:</b>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div
                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <button class="btn-sm bg-transparent border-0 d-flex align-items-center">
                                            <span class="material-icons-outlined cursor-pointer">search</span>
                                        </button>
                                        <input name="name" v-model="filters.search"
                                               class="form-control form-control border-0 py-0 pl-0 shadow-none form-input"
                                               placeholder="Search"/>
                                    </div>
                                </div>


                            </div>
                            <br/>
                        </div>
                        <thead class="clickable-header" slot="header" slot-scope="{ tableFilter }">
                        <tr>
                            <th :class="editableRow ? 'smaller-padding' : ''">
                                <input type="checkbox" v-model="allSelected" @change="selectAll"/>
                            </th>
                            <th @click="sort(column.id)" v-if="column.label!=='' && column.visible===true"
                                v-for="column in columns"
                                :class="editableRow ? 'smaller-padding' : ''">
                                <span> {{ column.label }} </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody slot="body" slot-scope="{ data }">
                        <tr
                            :key="colli.id"
                            v-for="(colli,key) in data">
                            <td v-if="column.visible===true"
                                :key="column.name"
                                v-for="column in columns"
                                :class="editableRow ? 'smaller-padding' : ''"
                            >
                                <data-table-cell
                                    :value="colli"
                                    :name="column.name"
                                    :meta="column.meta"
                                    :comp="column.component"
                                    :classes="column.classes">
                                </data-table-cell>

                                <slot v-if="column.label === ''">
                                    <input type="checkbox"
                                           v-on:change="onColliChecked()"
                                           v-model="collis[colli.id]"
                                    >
                                </slot>

                                <slot v-if="column.label === 'Id'">
                                    {{ colli.id }}
                                </slot>

                                <slot v-if="column.label === 'Client'">
                                    <div v-if="editableRow==colli.id"
                                         class="align-items-center bg-white border rounded-lg div-focus border-2">
                                        <v-select
                                            required
                                            :options="clientList"
                                            v-model="newColli.client"
                                            label="name"
                                            :closeOnSelect="false"
                                            v-on:input="getClientBookings($event)"
                                        >
                                        </v-select>
                                    </div>
                                    <div v-else>
                                        {{ colli.client.name }}
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Booking'">
                                    <div v-if="editableRow==colli.id"
                                         class="align-items-center bg-white border rounded-lg div-focus border-2">
                                        <v-select
                                            required
                                            :options="bookingList"
                                            v-model="newColli.booking"
                                            label="id"
                                        >
                                        </v-select>
                                    </div>
                                    <div v-else>
                                            <span v-if="colli.booking!=null && colli.booking.id!=1 ">
                                                <a :href="`/bookings/${colli.booking.id}/edit`">
                                                    #B-{{ colli.booking.id }}
                                                </a>
                                            </span>
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Colli reference'">
                                    <div v-if="editableRow==colli.id"
                                         class="d-flex align-items-left bg-white border rounded-lg div-focus
                                            border-2">
                                        <input type="text"
                                               required
                                               autocomplete="off"
                                               class="form-control text-left border-0 py-0 shadow-none form-input"
                                               v-model="newColli.reference"
                                        >
                                    </div>
                                    <div v-else>
                                        {{ colli.reference }}
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Colli name'">
                                    <div v-if="editableRow == colli.id"
                                         class="d-flex align-items-left bg-white border rounded-lg div-focus
                                            border-2">
                                        <input type="text"
                                               required
                                               autocomplete="off"
                                               class="form-control text-left border-0 py-0 shadow-none form-input"
                                               v-model="newColli.name"
                                        >
                                    </div>
                                    <div v-else>
                                        {{ colli.name }}
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Received'">
                                    <div v-if="editableRow==colli.id"
                                         class="d-flex align-items-left bg-white border rounded-lg div-focus  border-2">
                                        <date-picker
                                            required
                                            manual-input
                                            v-model="newColli.received" valueType="format"
                                            input-class="border-0 py-0 shadow-none form-input"
                                            placeholder="dd-mm-yyyy HH:mm" format="DD-MM-YYYY HH:mm"
                                            :lang="datePickerOptions.lang"
                                        >
                                        </date-picker>
                                    </div>
                                    <div v-else class="d-flex align-items-center">
                                        <span>{{ colli.received }}</span>
                                        <span class="material-symbols-outlined ml-2 text-danger cursor-pointer"
                                              v-if="colli.received"
                                              title="Unreceive"
                                              @click="toggleModalUnreceive($event, colli)"
                                        >
                                            cancel
                                        </span>
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Delivery'">
                                    <div v-if="editableRow==colli.id"
                                         class="d-flex align-items-left bg-white border rounded-lg div-focus  border-2">
                                        <date-picker
                                            required
                                            manual-input
                                            v-model="newColli.delivery" valueType="format"
                                            input-class="border-0 py-0 shadow-none form-input"
                                            placeholder="dd-mm-yyyy" format="DD-MM-YYYY"
                                            :lang="datePickerOptions.lang"
                                        >
                                        </date-picker>
                                    </div>
                                    <div v-else>
                                        {{ colli.delivery }}
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Location'">
                                    <div v-if="editableRow==colli.id"
                                         class="align-items-center bg-white border rounded-lg div-focus border-2">
                                        <v-select
                                            required
                                            :options="locationList"
                                            v-model="newColli.location"
                                            label="name"
                                            value="colli.location"
                                        >
                                        </v-select>
                                    </div>
                                    <div v-else>
                                        <div class="form-group align-items-center div-focus">
                                            <div v-for="(location,key) in colli.grouppedByLocations">
                                                {{ key.split('(')[0] }}
                                                ({{ location }})
                                                ({{ key.split('(')[1] }} <br/>
                                            </div>
                                            <div @click="toggleModalLog(colli.colli_batch)"
                                                 class="material-icons-outlined cursor-pointer"
                                                 title="">arrow_right
                                            </div>
                                        </div>

                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Volume'">
                                    <div v-if="editableRow==colli.id"
                                         class="d-flex align-items-left bg-white border rounded-lg div-focus
                                            border-2">
                                        <input type="text"
                                               required
                                               autocomplete="off"
                                               class="form-control text-left border-0 py-0 shadow-none form-input"
                                               v-model="newColli.totalVolume"
                                        >
                                    </div>
                                    <div v-else>
                                        {{ colli.totalVolume }}
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Weight'">
                                    <div v-if="editableRow==colli.id"
                                         class="d-flex align-items-left bg-white border rounded-lg div-focus
                                            border-2">
                                        <input type="text"
                                               required
                                               autocomplete="off"
                                               class="form-control text-left border-0 py-0 shadow-none form-input"
                                               v-model="newColli.totalWeight"
                                        >
                                    </div>
                                    <div v-else>
                                        {{ colli.totalWeight }}
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Colli number'">
                                    <div v-if="editableRow==colli.id">
                                        <div class="form-group d-flex align-items-center div-focus">
                                            <div
                                                @click="removeSingleColliFromBatch"
                                                class="material-icons-outlined cursor-pointer text-primary"
                                                title="remove colli">remove
                                            </div>
                                            <span :class="'colli_number_'+colli.id">
                                               {{ newColli.amount || newColli.totalColliAmountByColliBatch }}
                                            </span>
                                            <div
                                                @click="addSingleColliToBatch"
                                                class="material-icons-outlined cursor-pointer text-primary"
                                                title="add colli">add
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="form-group d-flex align-items-center div-focus">
                                            <div>
                                                {{ colli.totalColliAmountByColliBatch }}
                                            </div>
                                            <div @click="toggleModalBatch(colli.colli_batch)"
                                                 class="material-icons-outlined cursor-pointer"
                                                 title="">arrow_right
                                            </div>
                                        </div>
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Created By'">
                                    <div v-if="colli.createdBy!==null">
                                        {{ colli.createdBy }}
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Images'">

                                    <i v-if="colli.images.length>0" style="cursor: pointer;" class="oi oi-image"
                                       @click="toggleModalImageDetails(colli.colli_batch)">
                                    </i>
                                </slot>

                                <slot v-if="column.label === 'Edit'">
                                    <div class="edit-colli"
                                         v-if="editableRow != colli.id"
                                         title="Edit Colli"
                                         :id="colli.id"
                                         @click="setEditableRow(colli)"
                                    >
                                        <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                    </div>
                                    <div v-else class="d-flex">
                                        <span class="material-icons-outlined cursor-pointer mr-2 text-success"
                                              title="Save"
                                              @click="updateColli"
                                        >
                                            check
                                        </span>
                                        <span class="material-icons-outlined cursor-pointer mr-1 text-danger"
                                              title="Cancel"
                                              @click="cancelUpdateColli"
                                        >
                                            close
                                        </span>
                                    </div>
                                </slot>
                            </td>
                        </tr>
                        </tbody>

                        <div slot="pagination" slot-scope="{ links, meta }"
                             class="d-flex justify-content-between align-items-center"
                        >
                            <div>
                                <label class="pr-2">Collis per page:</label>
                                <div class="d-inline-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <select class="form-control bg-white border-0 py-0 shadow-none"
                                            v-model="filters.length"
                                            style="width: 150px;">
                                        <option
                                            :key="index"
                                            :value="records"
                                            v-for="(records, index) in perPage">
                                            {{ records }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <pagination
                                ref="pagination"
                                :total-pages="meta.last_page"
                                :current-page-prop="meta.current_page"
                                v-if="meta && meta.last_page > 1"
                            ></pagination>
                        </div>
                    </data-table>
                </div>
                <br/>
                <div class="d-flex justify-content-between">
                    <div>
                        <div @click="toggleModal()" v-if="role !== 'user'"
                             class="btn btn-success d-flex align-items-center float-left"
                             title="move location">
                            <span class="">Move location</span>
                        </div>

                        <div @click="printLabels()"
                             class="btn btn-success d-flex align-items-center float-left print-labels"
                             title="Print label(s)">
                            <span class="">Print label(s)</span>
                        </div>

                        <div
                            @click="deleteCollis()" v-if="role !== 'user'"
                            class="btn btn-primary d-flex align-items-center float-left delete-button"
                            title="Delete colli">
                            <div class="material-icons-outlined cursor-pointer mr-1"
                                 title="delete">delete
                            </div>
                            <span class="">Delete</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalEmail}"
            tabindex="-1"
            role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Send list of received goods</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalEmail()"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="sendListOfReceivedGoods">
                            <div class="pt-3">
                                <strong>Period</strong> <br/>
                                <div class="form-group">
                                    <div class="col-md-6">
                                        <date-picker
                                            aria-required="true"
                                            manual-input
                                            v-model="listOfReceivedGoods.dateFrom" valueType="format"
                                            @input="getListOfReceivedGoods"
                                            input-class="border-0 py-0 shadow-none form-input"
                                            :lang="datePickerOptions.lang"
                                            placeholder="dd-mm-yyyy" format="DD-MM-YYYY">
                                        </date-picker>
                                    </div>

                                    <div class="col-md-6">
                                        <date-picker
                                            aria-required="true"
                                            manual-input
                                            v-model="listOfReceivedGoods.dateTo" valueType="format"
                                            @input="getListOfReceivedGoods"
                                            input-class="border-0 py-0 shadow-none form-input"
                                            :lang="datePickerOptions.lang"
                                            placeholder="dd-mm-yyyy" format="DD-MM-YYYY">
                                        </date-picker>
                                    </div>
                                </div>
                            </div>

                            <div class="pt-3">
                                <strong>Who do you want to send the list to?</strong> <br/>
                            </div>

                            <div class="pt-3">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th class="border-right text-left">Client</th>
                                            <th class="border-right text-left">Send</th>
                                            <th class="border-right text-left">Email</th>

                                        </tr>
                                        </thead>
                                        <tbody class="table-bordered">
                                        <tr>
                                            <td>Step Booking</td>
                                            <td><input type="checkbox" v-model="listOfReceivedGoods.sendCopyToOwner">
                                            </td>
                                            <td>booking@steptransport.dk</td>
                                        </tr>
                                        <tr v-for="(item,k) in listOfReceivedGoods.goods">
                                            <td>{{ item.client.name }}</td>
                                            <td>
                                                <input type="checkbox"
                                                       v-model="listOfReceivedGoods.selectedClients[item.client.id]">
                                            </td>
                                            <td>{{ item.client.email }}
                                                <div
                                                    class="d-inline-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                    <select class="form-control bg-white border-0 py-0 shadow-none"
                                                            v-model="listOfReceivedGoods.selectedEmail[item.client.id]"
                                                            style="width: 150px;">
                                                        <option
                                                            v-for="(item, index) in item.client.contacts"
                                                            :value="item.email"
                                                            v-bind:selected="index === 0"
                                                        >
                                                            {{ item.email }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>


                            <button class="btn btn-success">
                                Send emails
                            </button>
                            <div class="btn btn-primary" @click="toggleModalEmail">
                                Cancel
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalEmail" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalImage}"
            tabindex="-1"
            role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Select image for selected collis</h5>

                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalImage()"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="storeImage">
                            <div class="form-group">
                                <input title="Import location" class="custom-file-input-" type="file"
                                       @change="addImage" ref="file" name="file">
                            </div>

                            <div class="form-group">
                                <button
                                    class="btn btn-success d-flex align-items-center float-left"
                                    title="Save">
                                    <span class="">Upload</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalImage" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalImageDetails}"
            tabindex="-1"
            role="dialog">
            <div class="modal-dialog colli-grouped" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"></h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalImageDetails(null)"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="pt-3">
                            <div v-for="item in imageDetailsData">
                                <div v-if="item.filename.includes('.pdf?')">
                                    <a :href="item.download.url" target="_blank"> download pdf file</a> <br/> <br/>
                                </div>
                                <div v-else>
                                    <img width="128px" alt="" :src="item.download_url">
                                    <a :href="item.download_url" target="_blank"> download</a> <br/> <br/>
                                </div>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalImageDetails" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalLog}"
            tabindex="-1"
            role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Colli locations log</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalLog(1)"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="pt-3">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th class="border-right text-left">Date</th>
                                        <th class="border-right text-left">Move to a location</th>
                                        <th class="border-right text-left">By Who</th>
                                    </tr>
                                    </thead>
                                    <tbody class="table-bordered">
                                    <tr v-for="log in colliLog">
                                        <td>{{ formatDateTime(log.action_time) }}</td>
                                        <td>{{ log.description }}</td>
                                        <td>{{ log.initiated_by }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="btn btn-primary" @click="toggleModalLog(1)">
                            Close
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalLog" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalBatch}"
            tabindex="-1"
            role="dialog">
            <div class="modal-dialog colli-grouped" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"></h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalBatch(null)"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="pt-3">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th class="border-right text-left">ID</th>
                                        <th class="border-right text-left">Client</th>
                                        <th class="border-right text-left">Booking</th>
                                        <th class="border-right text-left">Reference</th>
                                        <th class="border-right text-left">Delivery</th>
                                        <th class="border-right text-left">Location</th>
                                        <th class="border-right text-left">Volume</th>
                                        <th class="border-right text-left">Weight</th>
                                    </tr>
                                    </thead>
                                    <tbody class="table-bordered">
                                    <tr v-for="colli in colliGrouppedByColliBatch">
                                        <td>{{ colli.id }}</td>
                                        <td>{{ colli.client.name }}</td>
                                        <td>
                                            <span v-if="colli.booking!=null && colli.booking.id!=1">
                                             #B-{{ colli.booking.id }}
                                           </span>
                                        </td>
                                        <td> {{ colli.reference }}</td>
                                        <td> {{ colli.created_at }}</td>
                                        <td>
                                            <span v-if="colli.location!==null">
                                                #{{ colli.location.name }} ({{ colli.colli }})
                                                ({{ colli.location.warehouse.nickname }})
                                            </span>
                                        </td>
                                        <td> {{ colli.volume }}</td>
                                        <td> {{ colli.weight }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalBatch" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Move location</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="moveLocation">
                            <div class="form-group">
                                <v-select
                                    required
                                    :options="locationList"
                                    v-model="newLocationToMove"
                                    label="name"
                                    value="colli.location"
                                >
                                </v-select>
                            </div>
                            <button class="btn btn-primary">
                                Save
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalUnreceive}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Unreceive colli {{ unreceivedColli ? unreceivedColli.id : '' }}</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalUnreceive($event)"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-html="unreceiveModalText"></div>
                        <div class="text-danger" v-html="unreceiveModalError" v-if="unreceiveModalError"></div>
                    </div>
                    <div class="modal-footer">
                        <div v-if="!unreceiveModalError">
                            <button class="btn btn-success" @click="unreceiveColli">
                                Ja
                            </button>
                            <button class="btn btn-primary" @click="toggleModalUnreceive($event)">
                                Nej
                            </button>
                        </div>
                        <button class="btn btn-success" @click="toggleModalUnreceive($event)" v-else>
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalUnreceive" class="modal-backdrop fade show"></div>

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>
    </div>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from "vue-loading-overlay";
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import Pagination from "./reusable/Pagination.vue";
import dataTablePaginationMixin from "../mixins/dataTablePaginationMixin";
import dateTimeMixin from "../mixins/dateTimeMixin";
import modalMixin from "../mixins/modalMixin";

export default {
    components: {Loading, Pagination},
    mixins: [datePickerOptionsMixin, dataTablePaginationMixin, dateTimeMixin, modalMixin],
    name: "ColliDataTable",
    props: {
        url: {type: String, required: true},
        role: {type: String, required: true}
    },
    data() {
        return {
            tableUrl: this.url,
            isLoading: true,
            clientList: [
                {id: '', name: ''},
            ],
            warehouseList: [
                {id: '', nickname: ''},
            ],
            bookingList: [
                {id: '', note: ''},
            ],
            locationList: [
                {id: '', name: ''},
            ],
            collis: {},
            colliLog: {},
            newLocationToMove: '',
            orderBy: 'id',
            orderDir: 'desc',
            search: '',
            perPage: [10, 25, 50, 100],
            filters: {
                search: '',
                length: 25,
                column: 'id',
                dir: 'desc',
                clientId: '',
                warehouseId: {'id': 1, nickname: 'Brøndby'},
                groupReferences: 0,
                groupByColliBatch: 1,
                showDelivered: false,
                excludeBookings: false,
                collis: [],
                loadingForColliDataTable: true
            },
            listOfReceivedGoods: {
                goods: {},
                dateFrom: this.predefinedTripData(),
                dateTo: this.predefinedTripData(),
                selectedClients: {},
                selectedEmail: {},
                sendCopyToOwner: true
            },
            loading: false,
            columns: [
                {
                    label: '',
                    id: '',
                    orderable: false,
                    visible: true,
                },
                {
                    label: 'Id',
                    id: 'id',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Client',
                    id: 'client',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Booking',
                    id: 'booking_id',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Colli reference',
                    id: 'colli_reference',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Colli name',
                    id: 'name',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Received',
                    id: 'received_at',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Delivery',
                    id: 'delivery',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Location',
                    id: 'location',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Volume',
                    id: 'volume',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Weight',
                    id: 'weight',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Colli number',
                    id: 'colli_number',
                    orderable: false,
                    searchable: false,
                    visible: true,
                },
                {
                    label: 'Created By',
                    id: 'created_by',
                    orderable: false,
                    searchable: false,
                    visible: this.role !== 'user'
                },
                {
                    label: 'Images',
                    id: 'images',
                    orderable: false,
                    searchable: false,
                    visible: true
                },
                {
                    label: 'Edit',
                    id: 'edit',
                    orderable: false,
                    visible: this.role !== 'user'
                },
            ],
            pagination: {
                align: "right",
                meta: {to: 1, from: 1}
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,
                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            translate: {
                nextButton: '',
                previousButton: '',
                placeholderSearch: 'Search'
            },
            allSelected: false,
            activeModalInterval: false,
            activeModalIntervalBatch: false,
            activeModalIntervalLog: false,
            activeModalIntervalEmail: false,
            activeModalIntervalImage: false,
            activeModalIntervalImageDetails: false,
            activeModalUnreceive: false,
            show: false,
            isSubmit: false,
            fileName: '',
            attachment: '',
            editableRow: null,
            newColli: {},
            colliGrouppedByColliBatch: {},
            dimensions: {'volume': 0, 'weight': 0},
            imageData: {},
            imageDetailsData: [],
            unreceiveModalText: '',
            unreceiveModalError: '',
            unreceivedColli: null,
        }
    },
    watch: {
        filters: {
            handler: function(newValue) {
                this.$refs.pagination.changePage('', 1);
            },
            deep: true
        }
    },
    methods: {
        sort(key) {
            if (key) {
                this.filters.column = key;
                this.filters.dir = this.filters.dir === 'asc' ? 'desc' : 'asc';
            }
        },
        fetchData() {
            this.getListOfReceivedGoods();
            axios.get('/warehouse-list')
                .then(({data}) => {
                    Object.entries(data).forEach(entry => {
                        const [key, value] = entry;
                        this.warehouseList.push({
                            id: value.id,
                            nickname: value.nickname,
                        });
                    });
                }).catch();
            axios.get('/client-list')
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.clientList.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                }).catch()
            this.locationSelectList();
            this.getDimensionsSum();
        },
        addImage(e) {
            this.imageData = new FormData();
            this.imageData.append('name', 'file');
            this.imageData.append('file', e.target.files[0]);
        },
        storeImage() {

            if (!this.filters.search) {
                this.imageData.append('isColliBatch', 1);
            } else {
                this.imageData.append('isColliBatch', 0);
            }

            this.imageData.append('collis', Object.keys(this.collis));
            axios.post(`/colli/store-image`, this.imageData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                this.flashMessage.success({
                    title: '',
                    message: `Image uploaded successfully`,
                    time: 2000,
                    blockClass: 'flash-message'
                });
                setTimeout(() => {

                    this.filters.search = '';
                    window.location.reload();
                }, 2000);
            }).catch(error => {
            });
        },
        locationSelectList() {
            axios.get('/location-list-select')
                .then(({data}) => {
                    Object.entries(data).forEach(entry => {
                        const [key, value] = entry;
                        this.locationList.push({
                            id: value.id,
                            name: `${value.name} (${value.warehouse.nickname})`,
                        });
                    });
                }).catch();
        },
        getBookingsListByColli() {
            if (this.editableRow > 0) {
                axios.get(`/booking-list-by-colli/${this.editableRow}`)
                    .then(({data}) => {
                        this.bookingList = [];
                        Object.entries(data.data).forEach(entry => {
                            const [key, value] = entry;
                            this.bookingList.push({
                                id: value.id,
                                note: `${value.id}, ${value.client.name}, ${value.dropoff_address != null ? value.dropoff_address.name : ''}, ${value.note.substring(0, 50)}`
                            });
                        });
                    }).catch()
            }
        },
        getClientBookings(event) {
            if (this.editableRow > 0) {
                axios.get(`/booking-list-by-client/${event.id}/1`)
                    .then(({data}) => {
                        //this.colli.booking = null;
                        this.bookingList = [];
                        Object.entries(data.data).forEach(entry => {
                            const [key, value] = entry;
                            this.bookingList.push({
                                id: value.id,
                                note: `${value.id}, ${value.client.name}, ${value.dropoff_address != null ? value.dropoff_address.name : ''}, ${value.note.substring(0, 50)}`
                            });
                        });
                    }).catch()
            }
            this.getDimensionsSum();
        },
        validation() {
            this.isSubmit = true;
        },
        sendListOfReceivedGoods() {
            axios.post(`/colli/send-received-collis`, this.listOfReceivedGoods).then((response) => {
                this.listOfReceivedGoods = {
                    goods: {},
                    dateFrom: this.predefinedTripData(),
                    dateTo: this.predefinedTripData(),
                    selectedClients: {},
                    selectedEmail: {}
                };
                this.getListOfReceivedGoods();
                this.editableRow = null;
                this.flashMessage.success({
                    title: '',
                    message: `Mail sent successfully`,
                    time: 2000,
                    blockClass: 'flash-message'
                });
            }).catch(err => console.log(err))
        },
        printLabels() {
            this.loading = true;
            let isForClients = this.role === 'user' ? 1 : 0;
            axios({
                url: `/colli/print-labels?isForClients=${isForClients}&isPrintByBooking=0`,
                method: 'POST',
                data: {ids: this.collis}
            }).then((response) => {
                this.collis = {};
                if (response.data.printnode === 'missing printer') {
                    alert('PDF generated, but not sent to print since printer id is missing');
                }
                if (response.data.file !== null) {
                    axios({
                        url: `/settings/download-file/print_labels_${response.data.file}`,
                        method: 'GET',
                        responseType: 'blob'
                    }).then((response) => {
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', `print_label.pdf`);
                        document.body.appendChild(fileLink);
                        fileLink.click();
                    }).catch((error) => {
                        console.log(error)
                    });
                }
            }).catch((error) => {
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message || 'Error',
                    time: 3000,
                    blockClass: 'flash-message error'
                });
                console.log(error)
            }).finally(() => {
                this.loading = false
            });
        },
        moveLocation() {
            axios.post(`/move-location/${this.newLocationToMove.id}`, this.collis)
                .then(({data}) => {
                    this.toggleModal();
                    this.flashMessage.success({
                        title: '',
                        message: `Colli moved to ${this.newLocationToMove.name}`,
                        time: 3000,
                        blockClass: 'flash-message'
                    });
                    this.collis = {};
                    this.$refs.table.getData();
                }).catch();
        },
        deleteCollis() {
            axios.post(`/delete-multiple-collis`, this.collis).then((response) => {
                this.collis = {};
                this.$refs.table.getData();
            }).catch(err => console.log(err))
        },
        updateColli() {
            if (this.role === 'user') {
                return;
            }
            if (this.editableRow) {
                axios.patch(`/collis/${this.editableRow}`, this.newColli).then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: `Colli data saved`,
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                    this.$refs.table.getData();
                }).catch(err => {
                    this.flashMessage.error({
                        title: '',
                        message: err.response.data.message,
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                    console.log(err.response.data);
                }).finally(() => {
                    this.editableRow = null;
                    this.newColli = {};
                });
            }
        },
        cancelUpdateColli() {
            this.editableRow = null;
            this.newColli = {};
        },
        setEditableRow(colli) {
            this.editableRow = colli.id;
            this.getBookingsListByColli();
            this.newColli = JSON.parse(JSON.stringify(colli))
        },
        addSingleColliToBatch() {
            if (this.newColli.amount === undefined) {
                this.$set(this.newColli, 'amount', parseInt(this.newColli.totalColliAmountByColliBatch));
            }
            this.$set(this.newColli, 'amount', (this.newColli.amount + 1));
        },
        removeSingleColliFromBatch() {
            if (this.newColli.amount === undefined) {
                this.$set(this.newColli, 'amount', parseInt(this.newColli.totalColliAmountByColliBatch));
            }
            if (this.newColli.amount > 1) {
                this.$set(this.newColli, 'amount', (this.newColli.amount - 1));
            }
        },
        toggleModalImageDetails(batch) {
            if (batch !== null) {
                axios.get(`/colli/images/${batch}`)
                    .then(({data}) => {
                        this.imageDetailsData = data.data;
                    }).catch()
            }
            this.modalToggle('activeModalIntervalImageDetails');
        },
        toggleModalEmail() {
            this.modalToggle('activeModalIntervalEmail');
        },
        toggleModalImage() {
            this.modalToggle('activeModalIntervalImage');
        },
        toggleModalBatch(batch) {
            if (batch !== null) {
                axios.post(`/colli-list-by-colli-batch`, {data: batch})
                    .then(({data}) => {
                        this.colliGrouppedByColliBatch = data.data;
                    }).catch()
            }
            this.modalToggle('activeModalIntervalBatch');
        },
        toggleModalLog(batch) {
            if (batch !== null) {
                axios.get(`/colli/log/${batch}`)
                    .then(({data}) => {
                        this.colliLog = data.data;
                    }).catch()
            }
            this.modalToggle('activeModalIntervalLog');
        },
        toggleModal() {
            this.modalToggle('activeModalInterval');
        },
        toggleModalUnreceive(e, colli = null) {
            this.unreceivedColli = colli;
            this.unreceiveModalError = '';
            this.unreceiveModalText = '';

            if (!this.activeModalUnreceive && colli && colli.booking) {
                axios.get(`/get-unreceive-modal-text/${colli.id}`)
                    .then((response) => {
                        if ('error' === response.data.status) {
                            this.unreceiveModalError = response.data.text;
                        } else {
                            this.unreceiveModalText = response.data.text;
                        }
                    }).catch((error) => {
                        this.unreceiveModalError = error.response.data.message;
                        console.log(error.response.data);
                });
            } else {
                this.unreceiveModalText = `Er du sikker på, at du vil fortsætte din handling?`;
            }
            this.modalToggle('activeModalUnreceive');
        },
        selectAll() {
            for (let i = 0; i < this.$refs.table.tableData.data.length; i++) {
                if (this.allSelected) {
                    this.$set(this.collis, this.$refs.table.tableData.data[i].id, true);
                } else {
                    this.$delete(this.collis, this.$refs.table.tableData.data[i].id);
                }
            }
        },
        predefinedTripData() {
            const currentDate = new Date();
            return currentDate.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '-' + (currentDate.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '-' + currentDate.getFullYear();
        }
        ,
        getListOfReceivedGoods() {
            axios.get(`/colli-list?receivedFrom=${this.listOfReceivedGoods.dateFrom}&receivedTo=${this.listOfReceivedGoods.dateTo}`)
                .then(({data}) => {
                    this.listOfReceivedGoods.goods = {};
                    if (data.data.length > 0) {
                        this.listOfReceivedGoods.goods = data.data;
                    }
                }).catch();
        },
        onColliChecked() {
            this.getDimensionsSum();
        },
        getDimensionsSum() {
            let requestData = {};
            requestData.filters = this.filters;
            requestData.collis = this.collis;
            axios.post('/colli-dimensions-sum', {params: requestData})
                .then(({data}) => {
                    this.dimensions.volume = data.volume;
                    this.dimensions.weight = data.weight;
                }).catch();
            return true;
        },
        async downloadImage(src) {
            try {
                // Fetch the image using the provided URL
                const response = await fetch(src);

                // Convert the image response to a blob
                const blob = await response.blob();

                // Create a blob URL for the image
                const url = window.URL.createObjectURL(blob);

                // Create a link element
                const link = document.createElement('a');
                link.href = url;
                link.download = imageName; // Set the desired file name

                // Append the link to the body
                document.body.appendChild(link);

                // Trigger a click on the link to start the download
                link.click();

                // Remove the link from the body
                document.body.removeChild(link);
            } catch (error) {
                console.error('Error downloading image:', error);
            }
        },
        unreceiveColli() {
            if (!this.unreceivedColli || !this.unreceivedColli.id) {
                return;
            }

            axios.post(`/unreceive-colli/${this.unreceivedColli.id}`)
                .then((response) => {
                    let colliId = this.unreceivedColli.id;
                    this.flashMessage.success({
                        title: '',
                        message: `Colli ${colliId} has been unreceived`,
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                    this.$refs.table.getData();
                    this.toggleModalUnreceive();
                    this.unreceivedColli = null;

                }).catch((error) => {
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message,
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                    console.log(error.response.data);

            });
        },
    },
    mounted() {
        this.$refs.table.$on("finished-loading", () => {
            this.isLoading = false;
        });

        this.$refs.table.$on("loading", () => {
            this.isLoading = true;
        });
    },
    created() {
        return this.fetchData()
    },
    filters: {
        number: function (value) {
            return value.toLocaleString('da-DK');
        }
    },
}
</script>
<style>
.custom-file-input::-webkit-file-upload-button {
    visibility: hidden;
}

.custom-file-input::before {
    content: 'Choose file';
    display: inline-block;
    border: 1px solid #999;
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 700;
    font-size: 10pt;
}

.custom-file-input:hover::before {
    border-color: black;
}

.custom-file-input:active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
}

.import-colli {
    margin-left: 20px;
    margin-right: 20px;
}

.delete-button {
    background-color: red !important;
    border-color: red !important;
}

.print-labels {
    margin-left: 20px;
    margin-right: 20px;
}

.send-list {
    margin-left: 150px;
}

.add-image {
    margin-left: 120px;
}

.edit-colli {
    color: #38688E;
}

.flash-message {
    z-index: 10000;
    position: absolute;
    top: 105px;
    left: 30%;
    right: 0;
    background-color: #ffffff !important;
    border: none !important;
}

.flash-message p {
    height: 16px;
    /* Label (Small) */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */
    letter-spacing: 0.02em;
    /* Dark Grey */
    color: #777777;
}

._vue-flash-msg-body__title {
    position: relative;
    width: 63px;
    height: 30px;
    left: 46px;
    top: 1px;
}

._vue-flash-msg-body__title:before {
    /* Label (Bold) */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */
    letter-spacing: 0.02em;
    color: #000000;
    content: "Success";
}

._vue-flash-msg-body__text {
    position: relative;
    left: 46px;
    top: 5px;
}

._vue-flash-msg-body__content:before {
    content: url('/checkmark_circle.png');
    left: 5px;
    top: 45%;
    position: relative;
}

.colli-number {
    position: relative;
    bottom: 0;
    margin-left: 5px;
    margin-right: 5px;
}

.additional-filters {
    margin-bottom: -20px;
}

.overflow-hidden {
    overflow: visible !important;
}

.button-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.button-container .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
}

.button-container .btn + .btn {
    margin-left: 10px;
}
.table .smaller-padding {
    padding-right: 0.3rem;
    padding-left: 0.3rem;
}
</style>
